// StyleSheet for the shared MaxBumpBanner. Lifted from mobile's
// workoutsListStyles.ts maxBump* block; takes a UiTheme so it renders
// identically on native and the web-rnw console. queueBanner* (the
// offline-outbox strip) stays mobile-only in workoutsListStyles.ts — a
// different, mobile-only concern.
import { StyleSheet } from "react-native";
import type { UiTheme } from "../theme";

export function makeStyles(theme: UiTheme) {
  const { palette: p, spacing: s, typography: t } = theme;
  return StyleSheet.create({
    wrap: {
      backgroundColor: p.surface2,
      borderColor: p.brand500,
      borderLeftWidth: 3,
      paddingHorizontal: s.s5,
      paddingVertical: s.s3,
      gap: s.s3,
    },
    header: {
      color: p.brand500,
      fontSize: t.sizes.xs,
      fontWeight: "700",
      letterSpacing: 0.6,
      textTransform: "uppercase",
    },
    row: {
      gap: s.s2,
    },
    label: {
      color: p.ink,
      fontSize: t.sizes.sm,
    },
    actions: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-end",
      gap: s.s2,
    },
  });
}
